export const SHARE_EMAIL = 'EMAIL';
export const SHARE_SLACK = 'SLACK';
export const THIRD_PARTY_APP_DELIVERY_TYPE = 'NONE';
export const SHARE_SLACK_APP_ID_NAME = 'Slack';
export const RECURRING_OPTION = 'RECURRING';
export const SEND_NOW_OPTION = 'NOW';
export const THIRD_PARTY_APP_CHANNEL = 'CHANNEL';
export const THIRD_PARTY_APP_USER = 'USER';